import React, { useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Carousel } from "react-bootstrap";
import img1 from "../assets/bulidingigm2.jpeg";
import img2 from "../assets/slider.jpg";
import img3 from "../assets/silder2.jpg";
import img4 from "../assets/silder3.jpg";
import "./home.css";
import Introduction from "../component/introduction/introduction";
import Services from "../component/services/service";
import ChooseEzymps from "../component/chooseezymps/chooseezymps";
import VissionMission from "../component/visionmission/vissionmission";
import ServicePackage from "../component/servicepackage/servicepackage";
import Contact from "../component/contact/contact";
import { useNavigate } from "react-router-dom";

const Homepage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const keyframes = `
    @keyframes zoomInOut {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }
  `;

  const carouselItemStyle = {
    position: "relative",
  };

  const imageStyle = {
    width: "100%",
    height: "700px",
    objectFit: "cover",
    animation: "zoomInOut 5s ease-in-out infinite",
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent black
    zIndex: 1,
  };

  const captionStyle = {
    zIndex: 2,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "#fff",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "left",
  };

  const buttonStyle = {
    marginTop: "15px",
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  };
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  const slides = [
    {
      img: img2,
      title: "Smart Manufacturing Solutions",
      subtitle: "Delivering Efficiency, Precision & Transparency",
      link: "/smart-manufacturing",
    },
    {
      img: img1,
      title: "EZYMPS",
      subtitle: "Empowering You with Rights, Responsibilities & Commitment",
      link: "/ezymps-page",
    },
    {
      img: img3,
      title: "Global Trade Expertise",
      subtitle: "Seamless Import & Export Services for Your Business",
      link: "/export-import",
    },
    {
      img: img4,
      title: "Innovative Trading Solutions",
      subtitle: "Building a Better Future Through Smart Commerce",
      link: "/innovative-trading",
    },
  ];

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <style>{keyframes}</style>
        <Carousel fade controls indicators interval={2000} pause={false}>
          {slides.map((slide, index) => (
            <Carousel.Item
              key={index}
              data-aos="zoom-in"
              style={carouselItemStyle}
              onClick={() => navigate(slide.link)}
            >
              <img
                src={slide.img}
                alt={`Slide ${index}`}
                style={imageStyle}
                className="d-block w-100"
              />

              <div style={overlayStyle}></div>
              <div style={captionStyle} className="container">
                <h1 className="font-size" data-aos="fade-down">
                  {slide.title}
                </h1>
                <div data-aos="fade-left">
                  <h1 className="middle-text">{slide.subtitle}</h1>
                  <button
                    style={buttonStyle}
                    className="quote-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      scrollToContact();
                    }}
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
        <div id="about">
          <ChooseEzymps />
        </div>
        <VissionMission />

        <div id="services">
          <Services />
        </div>
        <Introduction />
        <ServicePackage />
        {/* <Market /> */}

        <div ref={contactRef} id="contact">
          <Contact />
        </div>
      </div>
    </>
  );
};

export default Homepage;
